import { Provider } from '@angular/core'

import { CHAT_FACADE } from '@ti/core/contracts/chat'

import { FleetChatFacade } from './chat.facade'
import { ChatNotificationsHandler } from './chat-notifications.handler'
import { ChatUpdatesListener } from './chat-updates.listener'

export const provideChatFacade = (): Provider[] => {
  return [
    ChatNotificationsHandler,
    ChatUpdatesListener,
    FleetChatFacade,
    { provide: CHAT_FACADE, useExisting: FleetChatFacade },
  ]
}
